/* eslint-disable eqeqeq */
import CryptoJS from "crypto-js";

export const encryptAES = (data, mode = 2) => {
  let dataToEncrypt;
  var secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY_1);
  var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_IV_1);
  if (mode == 2) {
    secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY_2);
    iv = CryptoJS.enc.Utf8.parse(sessionStorage.getItem("ivkey"));
  }
  if (typeof data === "string") {
    dataToEncrypt = data;
  } else if (typeof data === "object") {
    dataToEncrypt = JSON.stringify(data);
  } else {
    throw new Error("Unsupported data type for encryption");
  }

  const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, secretKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
};

export const decryptAES = (cipherText, mode = 2) => {
  var secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY_1);
  var iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_IV_1);
  if (mode == 2) {
    secretKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY_2);
    iv = CryptoJS.enc.Utf8.parse(sessionStorage.getItem("ivkey"));
  }
  const decrypted = CryptoJS.AES.decrypt(cipherText, secretKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

  try {
    return JSON.parse(decryptedText);
  } catch (error) {
    return decryptedText;
  }
};

// URL Parameter encryption utilities
export const encryptURLParam = (value, mode = 2) => {
  if (!value) return "";
  try {
    const encrypted = encryptAES(value, mode);
    // Make URL-safe by replacing characters that can cause issues in URLs
    return encodeURIComponent(encrypted);
  } catch (error) {
    console.error("URL param encryption error:", error);
    return value; // Return original value if encryption fails
  }
};

export const decryptURLParam = (encryptedValue, mode = 2) => {
  if (!encryptedValue) return "";
  try {
    const decoded = decodeURIComponent(encryptedValue);
    return decryptAES(decoded, mode);
  } catch (error) {
    console.error("URL param decryption error:", error);
    return encryptedValue; // Return original value if decryption fails
  }
};

// Encrypt multiple URL parameters
export const encryptURLParams = (params, mode = 2) => {
  const encryptedParams = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== null && value !== undefined && value !== "") {
      encryptedParams[key] = encryptURLParam(value, mode);
    }
  }
  return encryptedParams;
};

// Decrypt multiple URL parameters
export const decryptURLParams = (encryptedParams, mode = 2) => {
  const decryptedParams = {};
  for (const [key, value] of Object.entries(encryptedParams)) {
    if (value !== null && value !== undefined && value !== "") {
      decryptedParams[key] = decryptURLParam(value, mode);
    }
  }
  return decryptedParams;
};
